import { find, isEmpty } from 'lodash-es';

import * as api from './../../api/api.service';

class CategoryAddendaCtrl {
  sellers: any[];

  // currenlty this is only used to get the seller's CA terms URL
  elegibleSellers: any[];

  categoryTerms: any[];

  categoryResponses: any[];

  constructor(public $scope, private api: api.IApiService, public $sce) {
    'ngInject';
  }

  // TODO: Use $onChanges to make a copy of the non-primitive bindings being passed in here
  // This will ensure that we never modify the original object from within this component

  getSellerList() {
    return this.sellers;
  }

  getCategoryAddendaTerms() {
    return this.categoryTerms;
  }

  getTermsDownloadUrl(seller) {
    if (!isEmpty(seller) && seller.termsUrl) {
      return `/aptitude/buyer/${seller.termsUrl}`;
    }
  }

  getCategoryAddendaResponseForSeller(sellerId, caId, order) {
    var sellerTerms = find(this.categoryResponses, {
      sellerId: sellerId,
      caId: caId
    });

    if (!isEmpty(sellerTerms)) {
      return find(sellerTerms.responses, { order: order });
    }
  }
}

export const CategoryAddendaComponent = {
  controller: CategoryAddendaCtrl,
  template: require('./categoryAddenda.html'),
  bindings: {
    sellers: '<',
    categoryTerms: '<',
    categoryResponses: '<'
  }
};
